import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getDomainNameInstallation(domainName) {
  const response = await sendRequest(domainName)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(domainName) {
  const url = urls.proxyRequestSimultaneous
  const data = {
    requests: [
      {
        method: 'get',
        id: 'checkDomain',
        url: `${urls.checkDomainInstalled}${domainName}`,
      },
      {
        method: 'get',
        id: 'resolveDns',
        url: urls.resolveDomainDns.replace(/{domainName}/, domainName),
      },
    ],
  }
  const response = await Network.sendPostRequest(url, data)

  // const checkDomain = await Network.sendGetRequest(
  //   `${urls.checkDomainInstalled}${domainName}`,
  // )
  // const resolveDns = await Network.sendGetRequest(
  //   urls.resolveDomainDns.replace(/{domainName}/, domainName),
  // )
  // return {
  //   status: { code: 200 },
  //   response: {
  //     checkDomain: {
  //       body: checkDomain?.response || {},
  //     },
  //     resolveDns: {
  //       body: resolveDns?.response || {},
  //     },
  //   },
  // }

  return response
}

function parseResponse(response) {
  if (response && response.status.code === 200) {
    const rawData = response.response
    const data = Formatter.parseDomainDataResponse(rawData)

    return {
      statusCode: 200,
      data: data,
    }
  }
  return {
    statusCode: 404,
    message: 'store not found',
  }
}

export { getDomainNameInstallation }
